import { render, staticRenderFns } from "./Submitted.vue?vue&type=template&id=d1880fe8"
import script from "./Submitted.vue?vue&type=script&lang=ts"
export * from "./Submitted.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports